import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';
import { SLATypeDetails } from '../../../app-create-case/models/insurance-case.model';
import { CaseReportInfo } from '../../models/domain/CaseReportInfo';
import { SCConfig } from '../../../sc-config/constant/sc-config.constant';
import { CommonService } from '../../services/common.service';

@Component({
    selector: 'app-app-sla-details',
    templateUrl: './app-sla-details.component.html',
    styleUrls: ['./app-sla-details.component.scss'],
    standalone: false
})
export class AppSlaDetailsComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
    @Input() slaDetails: SLATypeDetails;
    @Input() caseReportList: CaseReportInfo[];
    @Input() readyForBillingDate: any;
    @Input() isEdit: boolean = true;
    @Input() compactLayout: boolean = false;
    @Input() currentRole: string = null;
    @Output() openRestartSLAModal = new EventEmitter<any>();
    @Input() hideOverdueBadge: boolean = false;

    slaStatus: string = null;
    slaStartDate: any = null;
    slaEndDate: any = null;
    slaInformedDate: any = null;
    slaExpireDate: string = '';
    currentUserRole: any = SCConfig.CurrentRole;
    isAllowedToRecalculate: boolean = false;
    translatedDelayReason: string = '';

    private readonly destroy$ = new Subject<void>();

    constructor(
        private readonly cdrf: ChangeDetectorRef,
        private readonly commonService: CommonService,
        private readonly translateService: TranslateService
    ) {}

    public ngOnInit(): void {
        const hasClearingRole = this.commonService.currentUserHasClearingRole();
        this.isAllowedToRecalculate =
            !this.isEdit &&
            (this.currentRole === this.currentUserRole.Admin || hasClearingRole) &&
            !this.readyForBillingDate;

        this.translateService.onLangChange.pipe(takeUntil(this.destroy$)).subscribe(() => {
            this.updateTranslatedDelayReason();
        });
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes['slaDetails']) {
            this.updateTranslatedDelayReason();
        }
    }

    public onRestartSLA(): void {
        if (!this.isAllowedToRecalculate) return;

        this.openRestartSLAModal.emit(true);
    }

    public ngAfterViewInit(): void {
        this.cdrf.detectChanges();
    }

    public ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    private updateTranslatedDelayReason(): void {
        const reason = this.slaDetails?.SLADelayReason;
        if (!reason) {
            this.translatedDelayReason = '';
            return;
        }
        const key = 'APP_CASES.' + reason;
        const translation = this.translateService.instant(key);
        this.translatedDelayReason = key === translation ? reason : translation;
    }
}
